import RichTextRenderer from "@/src/components/RichTextRenderer";
import { Body4 } from "@/src/components/typography/components/Body";
import { Legal1 } from "@/src/components/typography/components/Legal";
import { Redemption } from "nvs-types/dist/types/generated/contentful";
import TimelineHeadline from "./TimelineHeadline";
import { RichText } from "@/src/components/RichTextRenderer/types";

export type TimelineProps = {
  assetUrl: string;
  label: string;
  redemptionPeriod: string;
  description: RichText;
  assetDescription: string;
  legal?: RichText | null;
  ctaCopy?: string;
  ownedBy: string;
  redemption?: Redemption;
  analyticsData: any;
};

const Timeline = ({
  assetUrl,
  assetDescription,
  label,
  redemptionPeriod,
  description,
  legal,
  ctaCopy,
  ownedBy,
  redemption,
  analyticsData,
}: TimelineProps) => {
  return (
    <div className="laptop:block inline-flex gap-4">
      <div>
        <TimelineHeadline
          assetUrl={assetUrl}
          label={label}
          redemptionPeriod={redemptionPeriod}
          assetDescription={assetDescription}
          ctaCopy={ctaCopy}
          ownedBy={ownedBy}
          redemption={redemption}
          analyticsData={analyticsData}
        />
        <div className="max-w-[1109px]">
          <>
            {description && (
              <Body4 as="div" className="my-4">
                <RichTextRenderer richText={description} />
              </Body4>
            )}
            {legal && (
              <Legal1 as="div" className="text-gray-350">
                <RichTextRenderer richText={legal} />
              </Legal1>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
